import { useContext, useEffect } from '@wordpress/element';
import { dispatch } from '@wordpress/data';
import { store } from '../redux/store';
import { Metadados } from '../classes/Metadados';
import { useActionParam } from '../api/actions/action';
import ContextTela from '../pages/DicasOtimizacao/telaContext';
import { POST_ID } from './Variables';


export default function GuardarMetadadosRedux (inicial = false) {
  const { mutateAsync, data } = useActionParam();
  const { tela } = useContext(ContextTela);

  useEffect(() => {
    if (inicial) obterDados();
  }, []);

  useEffect(() => {
    if (tela?.length > 0 && inicial) {
      window.addEventListener(`metadados_${tela}`, () => obterDados());
    }
  }, [tela]);

  const obterDados = () => {
    mutateAsync({
      action: 'buscar_meta_dados',
      param: {
        post_id: parseInt(POST_ID),
      },
    });
  };

  useEffect(() => {
    if (data?.data) {
      const metas = new Metadados({
        slug: data.data.slug,
        permalink: data.data.link_permanente,
        palavraChave: data.data.palavra_chave,
        metaDescription: data.data.meta_descricao,
        tituloSeo: data.data.title_seo,
        titulo: data.data.titulo,
        autor: data.data.autor,
        altImagem: data.data.alt_imagem,
        iconUrl: data.data.icone_url,
        thumbnailUrl: data.data.thumbnail_url,
        metaRobots: data.data.meta_robots,
        canonical: data.data.canonical,
        breadcrumbs: data.data.breadcrumbs,
        noindex: data.data.meta_robots_noindex,
        nofollow: data.data.meta_robots_nofollow,
      });
      dispatch(store).guardarMetaDados(metas);
    }
  }, [data]);

  return { obterDados };
};
